import { render } from "./StatisticalChart.vue?vue&type=template&id=593e896b&scoped=true"
import script from "./StatisticalChart.vue?vue&type=script&lang=js"
export * from "./StatisticalChart.vue?vue&type=script&lang=js"

import "./StatisticalChart.vue?vue&type=style&index=0&id=593e896b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-593e896b"]])

export default __exports__